import { render, staticRenderFns } from "./rule-header.vue?vue&type=template&id=253e363b&scoped=true&class=rule-entry"
import script from "./rule-header.vue?vue&type=script&lang=js"
export * from "./rule-header.vue?vue&type=script&lang=js"
import style0 from "./rule-header.vue?vue&type=style&index=0&id=253e363b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e363b",
  null
  
)

export default component.exports